import {notLoggedIn, onArticlePage} from "./helpers"

const BANNER_CLASS = "ab-question-banner"

const TRANSLATIONS = {
  en: {
    question: "Anatomy exam coming up?",
    yes: "YES, HELP ME STUDY!",
    yesShort: "YES",
    no: "NOT RIGHT NOW",
    noShort: "NO",
    dismissStart: "Enjoy exploring Kenhub, the",
    dismissHighlight: "#1 platform",
    dismissEnd: "for learning anatomy."
  },
  zh: {
    question: "解剖学考试快到了？",
    yes: "好的，开始学习！",
    yesShort: "即刻登录",
    no: "稍后再说",
    noShort: "稍后",
    dismissStart: "欢迎探索科纳博Kenhub，",
    dismissHighlight: "广受好评",
    dismissEnd: "的解剖学学习平台。"
  },
  de: {
    question: "Anatomie-Prüfung steht an?",
    yes: "JA, HILF MIR BEIM LERNEN!",
    yesShort: "JA",
    no: "NICHT JETZT",
    noShort: "NEIN",
    dismissStart: "Viel Spaß beim Entdecken von Kenhub, der",
    dismissHighlight: "#1 Plattform",
    dismissEnd: "zum Anatomie lernen."
  },
  pt: {
    question: "Prova de anatomia chegando?",
    yes: "SIM, ME AJUDE A ESTUDAR!",
    yesShort: "SIM",
    no: "AGORA NÃO",
    noShort: "NÃO",
    dismissStart: "Aproveite o Kenhub, a",
    dismissHighlight: "plataforma #1",
    dismissEnd: "para aprender anatomia."
  },
  es: {
    question: "¿Se acerca tu examen de anatomía?",
    yes: "¡SÍ, AYÚDAME A ESTUDIAR!",
    yesShort: "SÍ",
    no: "AHORA NO",
    noShort: "NO",
    dismissStart: "Disfruta explorando Kenhub, la",
    dismissHighlight: "plataforma #1",
    dismissEnd: "para aprender anatomía."
  },
  fr: {
    question: "Examen d'anatomie en vue ?",
    yes: "OUI, AIDEZ-MOI À ÉTUDIER !",
    yesShort: "OUI",
    no: "PAS MAINTENANT",
    noShort: "NON",
    dismissStart: "Explorez Kenhub, la",
    dismissHighlight: "plateforme n°1",
    dismissEnd: "pour apprendre l'anatomie."
  }
}

function getTranslations() {
  const locale = window.gon.locale
  return TRANSLATIONS[locale] || TRANSLATIONS.en
}

function bannerHTML(iconsPath) {
  const t = getTranslations()
  return `
<div class="l-container">
  <div class="${BANNER_CLASS}">
    <div class="${BANNER_CLASS}__icon">
      <svg class="fa fa-graduation-cap-light">
        <use href="${iconsPath}#fa-graduation-cap-light">
        </use>
      </svg>
    </div>
    <div class="${BANNER_CLASS}__text">
      ${t.question}
    </div>
    <div class="${BANNER_CLASS}__actions">
      <button class="btn btn-primary ${BANNER_CLASS}__btn-yes"
              data-controller="article_question_banner"
              data-action="article_question_banner#open">
        <span class="${BANNER_CLASS}__label-full">
          ${t.yes}
        </span>
        <span class="${BANNER_CLASS}__label-short">
          ${t.yesShort}
        </span>
      </button>
      <button class="btn btn-outline ${BANNER_CLASS}__btn-no">
        <span class="${BANNER_CLASS}__label-full">
          ${t.no}
        </span>
        <span class="${BANNER_CLASS}__label-short">
          ${t.noShort}
        </span>
      </button>
    </div>
  </div>
</div>`
}

function dismissHTML() {
  const t = getTranslations()
  const highlight = `${BANNER_CLASS}__highlight`
  return `
<div class="l-container">
  <div class="${BANNER_CLASS} ${BANNER_CLASS}--dismissed">\
${t.dismissStart} \
<span class="${highlight}">${t.dismissHighlight}</span> \
${t.dismissEnd}\
  </div>
</div>`
}

export default function questionBannerForVisitorsOnArticles() {
  if (!onArticlePage()) return
  if (!notLoggedIn()) return

  const banner = document.querySelector(".ready-to-learn-banner")
  if (!banner) return

  banner.innerHTML = bannerHTML(window.gon.iconsPath)

  banner.querySelector(`.${BANNER_CLASS}__btn-no`)
    .addEventListener("click", () => {
      banner.innerHTML = dismissHTML()
      setTimeout(() => {
        banner.classList.add("ready-to-learn-banner--hiding")
        banner.addEventListener(
          "animationend",
          () => banner.remove(),
          {once: true}
        )
      }, 2000)
    })
}
